var React = require('react');
var moment = require('moment');
var labels = require('MemberJoinLabels');
var memberTypeChecker = require('../../../../../Scripts/React/MemberTypeChecker.jsx').step5;
var { $simpleSelect, $input, $datePicker } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var validationFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationFunctions.jsx');
var apiDataConstants = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/apiDataConstants.js');
var selectableDataFunctions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/selectableDataFunctions.jsx');

class MedicalSchool extends React.Component {
    constructor(props) {
        super(props);

        this.getFieldsMarkup = this.getFieldsMarkup.bind(this);
        this.getInstitutionProgramTypeCode = this.getInstitutionProgramTypeCode.bind(this);
        //this.getProgramDirectorMarkup = this.getProgramDirectorMarkup.bind(this);
        this.getProgramTypeMarkup = this.getProgramTypeMarkup.bind(this);
        this.getStateDropdownMarkup = this.getStateDropdownMarkup.bind(this);
        this.getInstitutionDropdownMarkup = this.getInstitutionDropdownMarkup.bind(this);
        this.getTitleString = this.getTitleString.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleOtherInstitutionChange = this.handleOtherInstitutionChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    componentDidMount() {
        // program degree always set to 'Not Applicable'
        this.props.updateStepState('medSchoolProgramDegree', 'Not Applicable');

        // default country to USA if it's not already set
        if (!memberTypeChecker.doNotDefaultCountryToUSA(this.props.appState.appType) && !this.props.stepState.medSchoolCountry) {
            this.props.updateStepState('medSchoolCountry', 'USA');
        }

        // The program type is hard-coded as "Medical School"
        if (memberTypeChecker.defaultProgramTypeToMedicalSchool(this.props.appState.appType)) {
            this.props.updateStepState('medSchoolProgramType', 'Medical School');
        }

        // The program type is hard-coded as "Training Program"
        if (memberTypeChecker.defaultProgramTypeToTrainingProgram(this.props.appState.appType)) {
            this.props.updateStepState('medSchoolProgramType', 'Training Program');
        }
    }

   /* getProgramDirectorMarkup() {
        if (!memberTypeChecker.addProgramDirectorFields(this.props.appState.appType)) {
            return null;
        }

        return <div>
            <div className={"field-wrap"}>
                <label>{labels.step5.programDirectorName}</label>
                <$input name="medSchoolProgramDirectorName" value={this.props.stepState.medSchoolProgramDirectorName} onChange={this.handleInputChange} />
            </div>

            <div className={"field-wrap"}>
                <label>{labels.step5.programDirectorEmail}</label>
                <$input name="medSchoolProgramDirectorEmail" value={this.props.stepState.medSchoolProgramDirectorEmail} onChange={this.handleInputChange} />
            </div>
        </div>;
    }*/

    getProgramTypeMarkup() {
        const programType = memberTypeChecker.defaultProgramTypeToMedicalSchool(this.props.appState.appType) ||
            memberTypeChecker.defaultProgramTypeToTrainingProgram(this.props.appState.appType)
            ? <input value={this.props.stepState.medSchoolProgramType} name="medSchoolProgramType" onChange={this.handleInputChange} disabled={true}/>
            : <$simpleSelect
                value={this.props.stepState.medSchoolProgramType} name="medSchoolProgramType" onChange={this.handleInputChange} validations={[validationFunctions.required]} />;

        return <div>
            <div className={"field-wrap"}>
                <label>{labels.step5.programType}</label>
                {programType}
            </div>
        </div>;
    }

    getTitleString() {
        if (memberTypeChecker.changeMedicalSchoolLabel(this.props.appState.appType)) {
            return labels.step5.trainingProgram;
        }

        return labels.step5.medicalSchool;
    }

    getInstitutionProgramTypeCode() {
        if (memberTypeChecker.defaultProgramTypeToTrainingProgram(this.props.appState.appType)) {
            return apiDataConstants.programTypeCodes.training;
        } else {
            return apiDataConstants.programTypeCodes.medSchool;
        }
    }

    getInstitutionDropdownMarkup() {
        if (this.props.appState.apiData.institutions && this.props.appState.apiData.institutions.length) {
            const otherInstMarkup = this.props.institutionHasOther(this.props.stepState.medSchoolInstitution)
                ? <div className={"field-wrap"}>
                    <label>{labels.step5.otherInstitution}</label>
                    <$input name="medSchoolCustomInstitution" onChange={this.handleOtherInstitutionChange} />
                </div> : null;

            return <div className={"field-wrap"}>
                <label>{labels.step5.institution}</label>
                <$simpleSelect
                    name="medSchoolInstitution"
                    titlefieldname="InstitutionName"
                    value={this.props.stepState.medSchoolInstitution}
                    programtypecode={this.getInstitutionProgramTypeCode()}
                    selectdatafunction={selectableDataFunctions.getInstitutionSelectableOptions}
                    userdefinedstate={this.props.stepState.medSchoolState}
                    userdefinedcountry={this.props.stepState.medSchoolCountry}
                    onChange={this.handleInputChange}
                    validations={[]}  />

                {otherInstMarkup}
            </div>;
        }
    }

    getStateDropdownMarkup() {
        return this.props.stepState.medSchoolCountry ? <div className={"field-wrap"} key={this.props.stepState.medSchoolCountry + "1"}>
                   <label key={this.props.stepState.medSchoolCountry + "2"}>{labels.step5.state}</label>
                   <$simpleSelect key={this.props.stepState.medSchoolCountry + "4"}
                   name="medSchoolState"
                   value={this.props.stepState.medSchoolState}
                   country={this.props.stepState.medSchoolCountry}
                   selectdatafunction={selectableDataFunctions.getApiStatesFromAllCountries}
                   onChange={this.handleStateChange}
                   validations={this.props.stateFieldIsRequired(this.props.stepState.medSchoolCountry) ? [validationFunctions.required] : []} />
               </div> : null;
    }

    getFieldsMarkup() {
        return <div>

            <div className={"field-wrap"}>
                <label>{labels.step5.country}</label>
                <$simpleSelect
                    value={this.props.stepState.medSchoolCountry}
                    selectdatafunction={selectableDataFunctions.getApiCountriesFromAllCountries}
                    name="medSchoolCountry"
                    onChange={this.handleCountryChange}
                    validations={[validationFunctions.required]} />
            </div>

            <div className={"field-wrap"}>
                {this.getStateDropdownMarkup()}
                {this.getProgramTypeMarkup()}
              
                {this.getInstitutionDropdownMarkup()}
            </div>

            <div className={"field-wrap"}>
                <label>{labels.step5.startDate}</label>
                <$datePicker
                    value={this.props.stepState.medSchoolStartDate && moment.utc(this.props.stepState.medSchoolStartDate).isValid() ? moment.utc(this.props.stepState.medSchoolStartDate).format('YYYY-MM-DD') : ""}
                    onInput={this.handleInputChange}
                    name="medSchoolStartDate"
                    type="date"
                    date-format="yyyy-mm-dd" validations={[validationFunctions.required, validationFunctions.date]} />
            </div>

            <div className={"field-wrap"}>
                <label>{labels.step5.endDate}</label>
                <$datePicker
                    value={this.props.stepState.medSchoolEndDate && moment.utc(this.props.stepState.medSchoolEndDate).isValid() ? moment.utc(this.props.stepState.medSchoolEndDate).format('YYYY-MM-DD') : ""}
                    onInput={this.handleInputChange}
                    name="medSchoolEndDate"
                    type="date"
                    date-format="yyyy-mm-dd" comparetodate={this.props.stepState.medSchoolStartDate} validations={[validationFunctions.required, validationFunctions.date, validationFunctions.dateGreaterThan]} />
            </div>

        </div>;
    }

    handleInputChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
    }

    handleCountryChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
        this.props.updateStepState('medSchoolInstitution', '');
        this.props.updateStepState('medSchoolState', '');
    }

    handleStateChange(event) {
        this.props.updateStepState(event.target.name, event.target.value);
        this.props.updateStepState('medSchoolInstitution', '');
    }

    handleOtherInstitutionChange(event) {
        if (event.target.value) {
            var programTypeConstant = this.props.stepState.medSchoolProgramType.toLowerCase().indexOf('training') >= 0
                ? apiDataConstants.programTypeCodes.training
                : apiDataConstants.programTypeCodes.medSchool;

            this.props.handleOtherInstitutionChange(this.props.stepState.medSchoolCountry, this.props.stepState.medSchoolState, programTypeConstant, 'medSchoolInstitution');
        }

        this.handleInputChange(event);
    }

    render() {
        if (memberTypeChecker.hideMedicalSchool(this.props.appState.appType)) {
            return null;
        }

        return <div className={"medical-school-container"}>
            <div className={"row"}>
                <div className={"panel"}>
                    <div className={"col-md-12"}>
                        <h3>{this.getTitleString()}</h3>
                    </div>
                    <div className={"edit"}>
                        <div className={"col-md-6"}>
                            {this.getFieldsMarkup()}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

module.exports = MedicalSchool;